export const containerWidth = 1140
export const containerPadding = 6
export const containerMobilePadding = 14
export const headerHeight = 66
export const headerMargin = 30
export const sectionMargin = 90
export const sectionMobileMargin = 40
export const blockTextHeight = 330
export const sidebarWidth = 250
export const contentWidth = 860
export const customHexForVideo = '#DA769F'
